module.exports = __webpack_public_path__ + "static/media/paymentHistory.06944cc1.svg";